import { Document, Page, Text, View, StyleSheet} from '@react-pdf/renderer';
import { style } from '../../../components/pdf/fontstyles';
import { AutoText } from '../../../components/pdf/autoText';

        
const departmentalCertificate = ({ result }) => (
  
              <View size="A4" style={style.page}> 
                 <Text style={[style.title, style.ArialBlack]}>COLLEGE RECOGNITION / AFFILIATION CERTIFICATE</Text>
        
               
                <Text style={[style.paragraph, { marginTop: 10 }]}>
                Certified that the {result.institutionName} is Recognized and aided by the Higher and Technical Education Department Maharashtra State and has been affiliated to Non agricultural University during the period when {result.employeeName} has
                rendered her services in this College.
                </Text>
          
                <Text style={[style.paragraph, { marginTop: 10 }]}>
                The College in question is started Since {result.establishmentDate}, on No Grant in aid basis and has been brought on 100% Grant in aid basis w.e.f. {result.aidedDate}
                </Text>

                      
                <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 40 }}>
                <Text>Place:  {result.placeOfRetirement}</Text>
                <Text style={[ style.ArialItalic,{ fontSize: 8 },{marginRight :50}]}>Head of Office</Text>
              </View>

              <Text style={{ marginTop: 5 }}>Date:</Text>


           </View>

);

export default departmentalCertificate;